var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ScriptableForm',{attrs:{"labelSize":"lg","drawerSize":"lg","props":_vm.props,"labelCols":4}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }